var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrintPdfIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 61684",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.25rem",
    height: "1.25rem",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mcice0vwpa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 556",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11283",
    style: {
      clipPath: "url(#mcice0vwpa)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 61588"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9420",
    d: "M-3625.609-4362.084h-2.071a1.43 1.43 0 0 1-1.566-1.568v-7.42a1.4 1.4 0 0 1 1.48-1.533q.893-.028 1.787 0c.286.008.38-.075.375-.371-.017-1.036-.009-2.072-.005-3.108 0-.569.2-.762.777-.762h11.074c.571 0 .766.2.768.771v3.464h1.543c.272 0 .545 0 .815.021a1.347 1.347 0 0 1 1.27 1.332q.025 3.9 0 7.808a1.372 1.372 0 0 1-1.412 1.361c-.722.016-1.445 0-2.217 0v2.042c0 .3.007.6 0 .893a.6.6 0 0 1-.658.646h-11.112c-.676 0-.846-.17-.847-.849-.002-.888-.001-1.779-.001-2.727zm0-1.219v-2.676c0-.745.161-.9.917-.9H-3613.659a.612.612 0 0 1 .67.681c.007.272 0 .545 0 .816v2.088h1.905c.522 0 .527 0 .527-.513v-7.069c0-.521-.006-.526-.514-.526h-16.47c-.491 0-.5.009-.5.5v4.893c0 .777-.009 1.554.011 2.33 0 .128.138.359.219.363.718.026 1.438.016 2.202.016zm1.21 3.563h10.193v-5.9h-10.194zm0-12.9h10.192v-2.984h-10.193z",
    transform: "translate(3629.299 4377.676)",
    style: {
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9421",
    d: "M-3581.494-4353.466a.836.836 0 0 1-.866-.849.856.856 0 0 1 .828-.856.861.861 0 0 1 .868.856.841.841 0 0 1-.83.849z",
    transform: "translate(3597.227 4362.849)",
    style: {
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9422",
    d: "M-3604.947-4337.739h2.561c.465 0 .743.239.736.613-.006.354-.274.591-.719.593q-2.619.007-5.238 0c-.444 0-.712-.239-.716-.595-.005-.374.272-.609.737-.611.88-.003 1.76 0 2.639 0z",
    transform: "translate(3614.986 4350.926)",
    style: {
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9423",
    d: "M-3604.968-4330.152h2.6c.443 0 .712.227.718.585s-.265.6-.7.6q-2.638.007-5.276 0c-.435 0-.706-.246-.7-.6s.275-.582.719-.584c.88-.004 1.76-.001 2.639-.001z",
    transform: "translate(3614.988 4345.737)",
    style: {
      strokeWidth: ".25px"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintPdfIcon);
export default __webpack_public_path__ + "static/media/PrintPDFIcon.4e17f0825af4bf208d5d287a3e13d5a8.svg";
export { ForwardRef as ReactComponent };